import { render, staticRenderFns } from "./app-multiselect.vue?vue&type=template&id=2f45cd60&lang=pug"
import script from "./app-multiselect.vue?vue&type=script&lang=ts"
export * from "./app-multiselect.vue?vue&type=script&lang=ts"
import style0 from "./app-multiselect.vue?vue&type=style&index=0&id=2f45cd60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports